var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLogged)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggleTheme()}}},[_vm._v("mdi-brightness-4")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }